// extracted by mini-css-extract-plugin
export default {"Container":"NewPassword_Container__asKVL"};